import { render } from "./TabNavigation.vue?vue&type=template&id=acf17bdc&scoped=true"
import script from "./TabNavigation.vue?vue&type=script&lang=js"
export * from "./TabNavigation.vue?vue&type=script&lang=js"

import "./TabNavigation.vue?vue&type=style&index=0&id=acf17bdc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-acf17bdc"]])

export default __exports__